export default {
sets: `Sets`,
stats: `Statistiques`,
discover: `Découvrir`,
guides: `Guides`,
settings: `Réglages`,
unsupportedBrowserBody: `Flashcards ne prend pas en charge ce navigateur. Téléchargez la dernière version de Chrome ou Opera, ou téléchargez notre application iPhone, ou Android`,
unsupportedBrowserTitle: `Navigateur non supporté`,
noData: `Aucune donnée à montrer`,
contactUsTitle: `Nous aimons entendre comment nos utilisateurs utilisent notre application et comment nous pouvons nous améliorer. Déposez-nous un message avec toutes les requêtes, telles que les demandes de fonctionnalités ou les rapports de bogues`,
rateAppStore: `Tarif dans AppStore`,
rateGoogle: `Taux dans Google Play`,
close: `proche`,
shareFriends: `Partager avec des amis`,
noCardsQ: `Vous n'avez pas de flashcards?`,
noCardsS: `Sélectionnez dans notre collection pour commencer`,
suggestSet: `Ensemble de suggestions`,
createOwn: `Crée le tien`,
search: `Recherche`,
loading: `Chargement`,
words: `Mots`,
downloads: `Téléchargements`,
export: `Exporter`,
import: `Importer`,
importing: `Importation ... ne fermez pas l'application`,
importPreview: `Importer un aperçu`,
howQuizlet: `Comment importer depuis Quizlet`,
cards: `Cartes`,
importPreviewStatus: `__ Les termes sont prêts à être annexés aux cartes ___ existantes`,
importPaste: `Collez vos cartes dans la TextArea ci-dessus`,
setTotalLimitReached: `Vous ne pouvez avoir que 3000 cartes dans une étude`,
studying: `En train d'étudier`,
learnt: `Appris`,
mastered: `Maîtrisé`,
new: `Nouveau`,
noTerm: `Pas de terme`,
noDef: `Aucune définition`,
cardSaved: `Carte enregistrée`,
reviews: `Commentaires`,
practices: `Les pratiques`,
flashcards: `Cartes flash`,
alerts: `Alertes`,
corrects: `Corriger`,
mistakes: `Erreurs`,
reviewCycle: `Cycle de révision`,
reviewsLeft: `Les critiques laissées`,
lastReview: `Dernier examen`,
nextReview: `Next Review`,
hideHistory: `Cacher l'histoire complète`,
showHistory: `Montrez l'histoire complète`,
strength: `Force`,
star: `Étoile`,
image: `Image`,
tag: `Étiqueter`,
added: `ajoutée`,
removed: `supprimé`,
reviewedFrom: `Examiné à partir de __`,
notifications: `Notifications`,
reviewedPractice: `Examiné __ par ___ pratiquer`,
successfully: `avec succès`,
unsuccessfully: `sans succès`,
termUpdated: `Terme mis à jour`,
defUpdated: `Définition mise à jour`,
flashcardCreated: `FlashCard créé`,
dropboxImage: `Vous devez permettre à Dropbox Sync pour ajouter des images`,
deleteImgConfirm: `Êtes-vous sûr de vouloir supprimer cette image?`,
uploading: `Téléchargement`,
save: `Sauver`,
uploadImageFail: `Impossible de télécharger l'image`,
imageUploaded: `Image téléchargée`,
setNotFound: `L'étude n'est pas trouvée!`,
notEnoughCards: `Pas assez de cartes!`,
of: `__ de ___`,
on: `Sur`,
off: `Désactivé`,
auto: `Automatique`,
manual: `Manuel`,
pronounce: `Prononcer`,
practiceCompleted: `Vous avez terminé cette pratique`,
closePractice: `Pratique étroite`,
autoplay: `Lecture automatique`,
secFlipSecNext: `__ Sec Flip, ___ SEC SUIVANT`,
autopronounce: `Automatiquement`,
onlyTerm: `SEULEMENT TERME`,
onlyDef: `Seule définition`,
termAndDef: `Terme et définition`,
savePractice: `Économiser la pratique?`,
continueLater: `Continuer plus tard`,
deletePractice: `Supprimer la pratique`,
term: `Terme`,
def: `Définition`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Examen de l'objectif`,
dailyGoal: `Objectif quotidien`,
edit: `Modifier`,
setUp: `D'installation`,
noRecentPractice: `Vous n'avez aucune pratique récente`,
continueLastReview: `Continuez la dernière revue`,
dueCards: `Cartes d'échéance`,
studyNow: `Etudies maintenant`,
newCards: `Nouvelles cartes`,
terms: `termes`,
defs: `définitions`,
validCardsOf: `Seules __ des cartes ___ sélectionnées peuvent être pratiquées, car les autres manquent le terme ou la définition`,
reviewCards: `Cartes de révision`,
customizePractice: `Personnaliser la pratique`,
next: `Suivant`,
iWasRight: `j'avais raison`,
printProAlert: `Veuillez acheter un abonnement Pro pour imprimer plus de 20 flashcards`,
print: `Imprimer`,
printWidth: `Largeur à terme-def`,
printFont: `Taille de police`,
printBorder: `Frontière`,
printMargin: `Marge de page`,
printPadding: `Rembourrage de mots`,
preparingFile: `Fichier de préparation`,
notificationsBlocked: `Les notifications ne sont pas activées, vous activez les notifications à partir des paramètres de votre téléphone`,
ranOutOfWords: `Manqué de cartes, redémarrez l'entraînement pour recommencer`,
ranOutOfWordsShort: `Manquer de mots`,
ranOutOfWordsBody: `Ouvrez l'application pour planifier de nouveaux mots`,
proIncreaseNotifications: `Vous pouvez augmenter les notifications totales de 10 à 50 dans la version premium.`,
schedule: `Programme`,
frequency: `La fréquence`,
mode: `Mode`,
tM1: `1 minute`,
tM2: `2 minutes`,
tM5: `5 minutes`,
tM10: `10 minutes`,
tM15: `15 minutes`,
tM30: `30 minutes`,
tH1: `1 heure`,
tH2: `2 heures`,
termPassive: `Terme passif`,
termActive: `Terme actif`,
defPassive: `Def passif`,
defActive: `Def actif`,
scheduledIn: `Planifié en __ minutes`,
scheduledAlertsProT: `Augmenter les alertes planifiables avec Pro`,
scheduledAlertsProB: `Vous pouvez augmenter les alertes planifiées de 10 à 50 avec le package pro`,
seeFeatures: `Voir les fonctionnalités`,
defAndTerm: `Définition et terme`,
termHoldDef: `Terme, tenir pour révéler la définition`,
defHoldTerm: `Définition, maintenez pour révéler le terme`,
notificationType: `Type de notification`,
copyToClipboard: `Copier dans le presse-papier`,
enterAuthCode: `Veuillez saisir votre code d'autorisation`,
invalidCode: `Code non valide fourni`,
copied: `Copié!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Appuyez pour découvrir toutes les fonctionnalités premium pour apprendre plus efficacement à votre rythme`,
promoBtn: `Découvrez toutes les fonctionnalités`,
setDropboxH2: `Synchronisation Dropbox`,
setDropboxPOff: `Activez la synchronisation Dropbox pour conserver vos ensembles, cartes flash, balises et progrès sauvegardés et mis à jour sur tous vos appareils.`,
setDropboxPOn: `Vos données sont sauvegardées et synchronisées sur vos appareils.`,
setDropboxBtn: `Synchronisation`,
status: `Statut`,
syncNow: `Synchroniser maintenant`,
contact: `Contacter`,
contactUs: `Nous contacter`,
useFromBrowser: `Utiliser à partir du navigateur`,
useFromBrowserMsg: `Visitez FlashcardsMadesImple.com sur votre ordinateur et restaurez vos cartes et licences en activant Dropbox Sync`,
termsPrivacy: `Termes et confidentialité`,
dailyReviewGoal: `Objectif de la revue quotidienne`,
numberTerms: `Nombre de termes`,
selectTerm: `Sélectionnez avec un indice du terme`,
selectDef: `Sélectionnez avec indice de définition`,
pronounceTerm: `Prononcer avec un indice à terme`,
pronounceDef: `Prononcer avec indice de définition`,
typeTerm: `Tapez avec un indice à terme`,
typeDef: `Tapez avec indice de définition`,
quizTypes: `Types de quiz préférés`,
spacedRepetition: `Calendrier de répétition espacé`,
spacedRepetitionP: `La répétition espacée vous permet de maîtriser les mots avec moins d'efforts en espacement progressivement du temps de révision. Le calendrier par défaut est le 1-3-7-15-31 jours, mais vous pouvez également en configurer un personnalisé.`,
spacedRepetionScheduleItem: `__ jours après ___ examen (jour ____)`,
atLeastOneSchedule: `Au moins un horaire est requis`,
revisionLimitReached: `Vous avez atteint le nombre maximal de revêtement`,
addReviewSchedule: `Ajouter un nouveau calendrier d'examen`,
autoMarkLearnt: `Marque automatique apprise après`,
autoMarkMastered: `Marque automatique maîtrisée après`,
tagManager: `Gestionnaire de balises`,
delete: `Supprimer`,
addTag: `Ajouter une nouvelle balise`,
tagDeletionH: `Suppression de tag`,
tagDeletionP: `Êtes-vous sûr de vouloir supprimer cette balise?`,
cancel: `Annuler`,
daysAfterLastReview: `Jours après la dernière revue`,
linkDropbox: `Lien dropbox`,
startSync: `Commencez à synchroniser`,
starred: `Vedette`,
images: `Images`,
tags: `Mots clés`,
types: `Les types`,
activeDays: `Jours actifs`,
inactiveDays: `Jours inactifs`,
longestStreak: `La plus longue série`,
dailyGoalsCompleted: `Objectifs quotidiens terminés`,
dailyGoalsFailed: `Les objectifs quotidiens ont échoué`,
typePairs: `Paires de types`,
reviewTypes: `Types d'examen`,
typePractice: `Type Practice`,
pronouncePractice: `Prononcer la pratique`,
selectPractice: `Sélectionnez la pratique`,
notificationReview: `Examen de la notification`,
flashcardReview: `Revue de cartes flash`,
studyset: `Studyset`,
enterStudysetName: `Veuillez saisir un nom pour votre étude`,
studysetName: `Entrez le nom du SET`,
termType: `Type de terme / Lang`,
defType: `Type de définition / lang`,
exportCards: `Cartes d'exportation`,
importCards: `Cartes d'importation`,
quiz: `Questionnaire`,
showingOutOfCards: `Affichage __ sur ___ cartes`,
showingAllCards: `Affichage de toutes les cartes, saisissez la barre de recherche ci-dessus ou appuyez sur n'importe quelle balise pour filtrer`,
recording: `Enregistrement`,
downloadSet: `Ajouter à mes ensembles`,
addNewCard: `Ajouter une nouvelle carte`,
saveStudyset: `Enregistrer l'ensemble d'étude`,
studysetDeletionH: `Suppression d'études`,
studysetDeletionP: `Êtes-vous sûr de vouloir supprimer cet étude, cela supprimera également toutes les cartes contenues.`,
cardDeletionH: `Suppression de la carte`,
cardDeletionP: `Êtes-vous sûr de vouloir supprimer cette carte`,
cardLimitReached: `Vous ne pouvez avoir que 3000 cartes dans une étude`,
limitExceeded: `Limite dépassée`,
atLeastTenCards: `Ajoutez au moins 10 cartes pour commencer les pratiques`,
searchInAll: `Rechercher dans tous les ensembles d'étude`,
noMatch: `Pas de correspondance`,
atLeastThreeChars: `Entrez au moins 3 caractères à rechercher`,
noSets: `Aucun ensemble`,
startingSync: `Démarrage de la synchronisation`,
noSetsP: `Sélectionnez parmi les options ci-dessous pour commencer`,
startingSyncP: `Nous obtenons vos données de Dropbox, cela pourrait prendre un certain temps`,
createNewStudyset: `Créer un nouvel studyset`,
restoreFromBackup: `Restaurer à partir du fichier de sauvegarde`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Sélectionnez le type de pratique`,
noDueCards: `Pas encore de cartes flash, les cartes flash que vous avez examinées auparavant commencera à apparaître ici après le calendrier de répétition espacé sélectionné pour vous aider à maîtriser les mots avec moins d'effort et de temps`,
noNewCards: `Pas de nouvelles cartes à étudier`,
subscriptionH: `Achetez Pro pour profiter de toutes les fonctionnalités et soutenir le développement continu.`,
buyLifetimePro: `Acheter Lifetime Pro pour __`,
restorePurchase: `Restaurer l'achat`,
termsPrivacyC: `Termes et politique de confidentialité`,
licenceShare: `Si vous avez acheté une licence à partir d'un autre appareil, vous pouvez le partager avec cet appareil en activant Dropbox Sync sur les deux appareils`,
enterTagName: `Entrez le nom de la balise`,
invalidName: `Nom incorrect`,
create: `Créer`,
name: `Nom`,
tagName: `Nom de votre balise`,
color: `Couleur`,
back: `Arrière`,
rowSeparator: `Séparateur de rangée`,
termDefSeparator: `Terme - Déparateur de Def`,
output: `Production`,
inputCards: `Cartes d'entrée`,
review: `La revue`,
language: `Langue`,
archiveReversible: `Archive (réversible à partir des paramètres)`,
deletePermanent: `Supprimer (irréversible)`,
archivedCards: `Cartes archivées`,
masteredCards: `Cartes maîtrisées`,
due: `Exigible`,
reviewed: `Révisé`,
markReviewed: `Mark examiné`,
markMastered: `Mark maîtrisé`,
forXYCards: `pour __ ___ cartes`,
createdAtSortBy: `Date de création`,
lastReviewedSortBy: `Dernière date d'examen`,
reviewCountSortBy: `Nombre d'examens`,
strengthSortBy: `Force`,
termSortBy: `Terme alphabétique`,
definitionSortBy: `Def.`,
ascSortBy: `Ascendant`,
descSortBy: `Descendant`,
featureSync: `Étudiez n'importe quoi, n'importe où, à tout moment avec vos flashcards synchronisés sur tous vos appareils`,
featureSpacedrepetition: `Recherchez vos progrès globaux et recommencez à pratiquer ce dont vous avez besoin pour pratiquer`,
featureNotifications: `Super-chargez votre apprentissage sans même ouvrir l'application avec des notifications flexibles`,
featureFlashcards: `Les flashcards de la lecture automatique lorsque vos mains ou vos yeux sont occupés, mais vous avez toujours une attention inutilisée`,
featureQuiz: `Faites correspondre, épeler, écouter ou sélectionner pour pratiquer vos flashcards`,
featureStats: `Acquérir de meilleurs informations sur vos cartes et résultats, et recherchez tous vos ensembles de cartes flash`,
featureImport: `Nous ne stockons jamais de données de vous et vous pouvez exporter et importer facilement toutes vos données`,
featurePrint: `Faites de l'apprentissage en imprimant vos flashcards et en bricant votre propre plate-forme d'étude`,
splashIntro: `Étudiez toutes vos flashcards n'importe où dans votre rythme et votre style`,
selectSortOrder: `Ordre de tri`,
selectSortProp: `Trier la propriété`,
applyFilters: `Appliquer des filtres`,
selectSetType: `Que voulez-vous pratiquer?`,
getStarted: `Commencer`,
tapToUnarchive: `Appuyez sur les cartes que vous souhaitez désarchives`,
untitled: `Sans titre`,
sortHintNew: `Vous verrez les cartes qui ont été créées il y a le plus longtemps en premier`,
sortHintDue: `Vous verrez des cartes qui sont dues depuis plus longtemps`,
sortHintOther: `Vous verrez des cartes qui n'ont pas été étudiées en premier`,
flashcardsWhen: `, lorsque vos mains ou vos yeux sont occupés, même en écoutant de la musique / des podcasts`,
notificationsWhen: `, pour quand vous êtes en déplacement et que vous voulez juste des bits d'étude rapides`,
quizWhen: `, car quand vous pouvez prêter une attention totale pour étudier, pour maîtriser vos cartes`,
features: `Caractéristiques`,
ratings: `Notes`,
notificationDailyCatchUpBody: `Nouveau: __, dû: ___, étudier: ____, appris: _____, maîtrisé: ______`,
notificationDailyCatchUpTitle: `Rattrapage quotidien`,
reviewedJN: `Examiné tout à l'heure`,
customUpdated: `Texte personnalisé mis à jour`,
customTextField: `Synonymes, exemples, etc.`,
field: `Domaine`,
link: `Lien`,
backToParentCard: `Retour à la carte parent`,
discard: `Jeter`,
failedImageLoad: `Échec de l'image, assurez-vous que vous êtes connecté à Internet`,
printDIYLabel: `DIY votre propre configuration d'étude sur papier créative, partagez avec nous votre création et figurez-vous dans l'application.`,
reviewGraphChart: `Examiner la fréquence`,
langNotSet: `Langue non définie`,
pronouncationLangInfo: `Pour activer la prononciation, vous devez sélectionner le terme et la langue de définition. Un panneau d'enceintes apparaîtra à côté des langues si votre appareil prend en charge cette langue`,
clearFilters: `Filtre effacer`,
subFreeUnlimited: `Études illimitées, cartes flash, pratiques, recherche et synchronisation`,
customFields: `Les champs personnalisés`,
subLinks: `Liens de carte`,
subPrint: `Impression / étude`,
subNotifications: `Notification avant de devoir ouvrir l'application`,
subCardsStudysets: `Cartes / studyset`,
subRevisionCycles: `Cycles de révision personnalisés`,
subscriptionHEnd: `La mise à niveau vers Pro nous montre que vous trouvez notre travail acharné précieux et nous donne des encouragements et un café pour continuer à améliorer et à créer de nouvelles choses incroyables.`,
subFree: `Libre`,
subPro: `Pro`,
guideSpacedRepetition: `Comment les types de répétition et de pratique espacés`,
guideSearch: `Recherche et filtrage`,
guideSync: `Activer la sauvegarde et la synchronisation entre vos appareils`,
guidePronunciation: `Activer les prononciations`,
guideImport: `Importer des cartes à partir de sources qui sortent`,
guideAccess: `Qui a accès à mes données?`,
guideData: `Quelles données collectons-nous?`,
guideContact: `Besoin d'aide avec autre chose? Écrivez-nous`,
arrowStrength: `Définissez comment vous connaissez cette carte`,
arrowImage: `Ajouter des images`,
arrowField: `Ajouter des champs de texte personnalisés supplémentaires`,
arrowTag: `Attacher les balises`,
arrowStar: `Marquez comme favori`,
arrowLink: `Lien vers d'autres cartes`,
arrowGoal: `Mettez en place un objectif de révision quotidien`,
arrowDue: `Étudier les mots qui doivent être examinés`,
arrowNew: `Cartes d'étude qui n'ont pas encore été examinées`,
arrowMastered: `Si vous n'avez pas de cartes dû ou nouvelles, vous pouvez consulter les cartes maîtrisées pour les garder maîtrisées`,
arrowImport: `Importez vos flashcards existants`,
arrowNewCard: `Ajouter une nouvelle flashcards`,
dropboxStep1: `1. Obtenez le code d'accès à partir de Dropbox en enregistrant`,
dropboxStep1Btn: `Connectez-vous avec Dropbox`,
dropboxStep2: `2. Entrez le code d'accès ci-dessous`,
dropboxStep2Input: `Entrez le code ici`,
dropboxStep3: `3. Commencez la synchronisation`,
alreadyLinked: `Déjà lié, appuyez pour dissocier`,
selectCardsToLink: `Sélectionnez des cartes pour lier`,
unsupportedLangP: `Sélectionnez une langue qui prend en charge la prononciation dans les paramètres de l'ensemble`,
links: `Liens`,
emailUs: `Envoyez-nous un e-mail`,
whatsappUs: `Whatsapp nous`,
printMinHeight: `Min. hauteur de rangée`,
exportType: `Type de fichier d'exportation`,
generateFileText: `Générer un fichier`,
generatatingFile: `Fichier de génération`,
verySmall: `Très petit`,
small: `Petit`,
normal: `Normal`,
big: `Gros`,
veryBig: `Très grand`,
repeatNTimes: `Répéter __ fois`,
pause: `Pause`,
for: `pour`,
say: `Dire`,
defShort: `DÉCONT.`,
times: `fois`,
autoplayPreferences: `Définir les préférences de lecture automatique`,
autoPlay1: `Pause après le mot précédent`,
autoPlay2: `Nombre de prononciations à terme`,
autoPlay3: `Pause avant de révéler la définition`,
autoPlay4: `Nombre de prononciations de définition`,
autoPlay5: `Pause avant de montrer le mot suivant`,
autoPlay6: `Répétez la même carte flash`,
startAutoPlay: `Démarrer la lecture automatique`,
autoPlayOffConfirm: `Éteignez la lecture automatique pour activer les commandes manuelles`,
turnOff: `Éteindre`,
keepPn: `Continuer à`,
foundIn: `Trouvé dans __`,
repeat: `répéter`,
stop: `Arrêt`,
listenInBreak: `Le saviez-vous? Vous pouvez écouter de la musique / des podcasts en pauses`,
contextSearch: `Recherche de contexte`,
contextSearchText: `Obtenez des exemples de la façon dont __ utilisé dans différentes phrases`,
transalteSearch: `Traduire`,
translateSearchText: `Traduire en ___`,
synonymSearch: `Recherche de synonyme`,
synonymSearchText: `Rechercher des synonymes de __`,
selectToAdd: `Sélectionnez les résultats que vous souhaitez ajouter à cette carte`,
addToCard: `Ajouter sélectionné à la carte`,
hideFromPractice: `Se cacher`,
setLanguageRequired: `Veuillez sélectionner la langue des termes et définitions dans les détails de l'étude`,
fieldNeedsText: `Entrez quelque chose dans ce champ avant de rechercher`,
possibleDupe: `Duplicate possible`,
loadNextXCards: `Chargez les cartes __ suivantes`,
repeatPractice: `Répétez ces cartes __`,
keepScreenOnInfo: `Vous devrez peut-être ajuster votre réglage automatique-verrouillage, pour garder l'écran allumé pendant la lecture automatique.`,
siteLoginH2: `Compte SFM`,
siteLoginP: `Vous pouvez utiliser votre compte simple Flashcards Made pour partager vos flashcards avec vos amis, vos élèves ou toute la communauté.`,
logOut: `Se déconnecter`,
logIn: `Connexion`,
createAccount: `Créer un nouveau compte`,
signUp: `S'inscrire`,
username: `Nom d'utilisateur`,
email: `E-mail`,
password: `Mot de passe`,
networkError: `Erreur de réseau`,
fillAllDetails: `Veuillez remplir tous les détails`,
noUserWithDetails: `Aucun utilisateur trouvé avec les détails entrés`,
userAlreadyExists: `L'e-mail ou le nom d'utilisateur donné existe déjà`,
signUpOrLoginToCont: `Inscrivez-vous ou connectez-vous pour continuer?`,
atLeastOneCardToShare: `Au moins une carte est nécessaire pour partager`,
publishingStudyset: `Édition de l'étude`,
updatesDetected: `Mises à jour détectées, voulez-vous procéder à la mise à jour des données locales? (Supprimé: __, mis à jour: ___, nouveau: ____)`,
updatesApplied: `Mises à jour appliquées`,
alreadyUpToDate: `Déjà à jour`,
practiceTypeArrow: `Découvrez différentes façons de pratiger`,
share: `Partager`,
sharingModalIntro: `Partagez vos flashcards dans cet ensemble avec vos amis, vos étudiants ou toute la communauté.`,
whatIsShared: `Ce qui est partagé`,
whatIsNotShared: `Ce qui n'est pas partagé`,
whatIsSharedText: `Définir le nom, définir la langue du terme, la langue de définir, toutes les cartes incluses avec des termes, des définitions, des champs de texte personnalisés et des images`,
whatIsNotSharedText: `Toutes les forces de la carte, les étoiles, les liens, les étiquettes et votre historique de critique`,
checkForSharedUpdates: `Vérifiez les mises à jour de Creator`,
fetchUpdates: `Récupérer les mises à jour`,
youSharedStudyset: `Vous avez partagé cet étude`,
publishChanges: `Enregistrer et publier des modifications`,
redeem: `Racheter`,
noAds: `Pas de pubs`,
dupeDetection: `Détection en double`,
coffeeFeature: `Café, pour nous aider à développer plus de fonctionnalités`,
shareLink: `Lien de partage`,
coffeeForUs: `Vous obtiendrez une licence à vie pour seulement __, ce qui donne à Emily 6 cafés, des cafés Dominik 3 et des cafés Russ 3, ce qui nous alimentera pendant environ 39 heures pour améliorer cet événement d'application`,
sharingCards: `Partage des cartes`,
published: `Publié`,
alreadyHaveAccount: `Vous avez déjà un compte?`,
notAlreadyHaveAccount: `Vous n'avez pas encore de compte?`,
startPractice: `Commencer à pratiquer`,
selectQuizTypes: `Sélectionnez des types de quiz`,
correct: `Corriger`,
incorrect: `Incorrect`,
yes: `Oui`,
no: `Non`,
levelSilver: `Niveau d'argent __`,
levelGold: `Niveau d'or __`,
levelPlatinum: `Niveau de platine __`,
levelDiamond: `Niveau de diamant __`,
levelJade: `Niveau de jade __`,
reviewsLeftGoal: `__ Avis pour l'objectif quotidien`,
dailyGoalAchieved: `L'objectif quotidien atteint`,
share: `Partager`,
rateApp: `Application de taux`,
allStats: `Toutes les statistiques`,
reviewTimeError: `Timeout après l'erreur`,
reviewTimeCorrect: `Timeout après correctement`,
pronounceTermAfterReview: `Prononcer le terme après examen`,
pronounceDefinitionAfterReview: `Prononcer la définition après examen`,
practice: `Entraine toi`,
notificationsScheduledInfo: `__ Les notifications ont été prévues, vous pouvez fermer l'application maintenant`,
wellDone: `Bon travail`,
keepItUp: `Continuez comme ça`,
youRock: `Tu gères`,
niceOne: `Joli`,
lnSelect: `Choisir la langue`,
sampleData: `Aucune revue, montrant des exemples de données`,
reviewFreq: `Examiner la fréquence`,
selectPractice: `Pratique: sélectionner`,
spellPractice: `Pratique: épeler`,
connectPractice: `Pratique: connecter`,
languages: `Langues`,
languagesPairs: `Paires de langues`,
shareArrow: `Partager un ensemble avec des amis, des étudiants ou toute la communauté`,
cardsPerRound: `Cartes / ronde`,
showAll: `Afficher tout`,
supportedLangsVary: `Les langues prises en charge varient`,
practiceWithoutSave: `Pratique non sauvée`,
practiceWithoutSaveBody: `Vous n'avez pas ajouté cet étude à votre collection, voulez-vous l'ajouter maintenant pour sauver vos progrès de l'étude?`,
saveSetNow: `Enregistrer les cartes à votre collection`,
continueWithoutSaveSave: `Commencez à pratiquer sans sauver`,
createdBy: `Créé par`,
setSavedToYourCollection: `Ensemble d'étude enregistré dans votre collection`,
accountBackupDisclaimer: `Veuillez noter que ce compte ne peut être utilisé que pour partager des études avec d'autres, et ne peut pas être utilisé pour sauvegarder ou synchroniser vos études ou cartes flash. Pour synchroniser et sauvegarder toutes vos données, veuillez utiliser Dropbox Sync`,
syncEnabled: `Synchronisation activée, récupérant votre contenu en cours`,
searchAllSets: `Ensembles d'étude de recherche d'autres utilisateurs`,
anyLanguage: `N'importe quel langage`,
trendingIn: `Dans les tendances`,
manualBackups: `Sauvegarde manuelle`,
manualBackupCreate: `Créer une sauvegarde manuelle`,
confirmManualImport: `Êtes-vous sûr de souhaiter remplacer toutes les données actuelles par cette sauvegarde? Ceci n'est recommandé que sur de nouveaux appareils sans aucune donnée`,
importFromManualBackup: `Importation de la sauvegarde`,
imgOfflineSets: `Images de téléchargement automatique pour l'apprentissage hors ligne`,
unsupportedDeviceCache: `Cette fonctionnalité n'est disponible que sur l'application iOS ou Android`,
shareChanges: `Partager __ Modifications`,
publiclySearchable: `Consultable par les utilisateurs`,
description: `La description`,
restoreFromDropboxBackup: `Restaurer à partir de la sauvegarde Dropbox`,
imageCacheStudysetSub: `[iOS & Android uniquement] Téléchargez l'image pour étudier hors ligne`,
keywordsOrLangNeeded: `Vous devez saisir des mots clés ou une seule langue`,
dropboxAlreadyLinked: `Le compte Dropbox est déjà lié`,
noSetUpdateAccess: `Vous n'avez pas accès à l'édition de cet ensemble d'étude.`,
confirmSetOwnerLogin: `Si vous êtes sûr que vous êtes le propriétaire, essayez à nouveau de vous connecter à votre compte.`,
uninitedRestriction: `Pour économiser vos progrès, vous devez d'abord ajouter cet étude à votre collection`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Échec de la consolidation du stockage`,
consolidateStorageDone: `Consolider le stockage, veuillez prévoir jusqu'à une heure pour que Dropbox finisse de supprimer les anciens fichiers avant de vous connecter sur un nouvel appareil.`,
consolidatingStorage: `Consolider le stockage ...`,
deleteAccount: `Supprimer le compte`,
consolidateStorageDescription: `Cette opération réindexera vos fichiers de sauvegarde, donc la configuration de nouveaux appareils sera plus rapide`,
consolidatingStorageConfirm: `Assurez-vous que toutes vos modifications ont déjà terminé la synchronisation, ne synchronisez pas d'autres appareils pendant que ce processus a lieu. Voulez-vous continuer?`,
consolidateStorage: `Consolider le stockage`,


}